import React, { useState } from 'react'
import styles from './signIn.module.css'
import { Button, Form, Input, message, Typography } from 'antd'
import { Link } from 'react-router-dom'
import { routePathSignIn } from './SignIn'
import { sendRestoreRequest } from '../../api/restore'

export const Restore = (): React.ReactElement => {
	const [form] = Form.useForm<{ email: string }>()
	const [loading, setIsLoading] = useState(false)

	async function onFinish({ email } : { email: string }) {
		const result = await sendRestoreRequest(email)

		if (result.success) {
			form.resetFields()
			void message.success(result.message)
		} else {
			void message.error(result.message)
		}

		setIsLoading(false)
	}

	return (
		<div className={styles['container']}>
			<Form
				className={styles['sign-in-block']}
				layout="vertical"
				form={form}
				onFinish={values => {
					setIsLoading(true)
					void onFinish(values)
				}}
			>
				<Typography.Title level={3} style={{ marginBottom: '25px' }}>
					Восстановление пароля
				</Typography.Title>

				<Form.Item
					name="email"
					label="Почта"
					rules={[{ required: true, message: 'Данное поле обязательно!' }]}
				>
					<Input
						placeholder="Введите в это поле почту"
					/>
				</Form.Item>

				<div style={{ display: 'flex', flexDirection: 'row' }}>
					<Link to={routePathSignIn} style={{ marginRight: 'auto' }}>
						Вернуться к авторизации
					</Link>

					<Typography.Link href="https://politcubes.com/actions">
						Ещё нет аккаунта?
					</Typography.Link>
				</div>

				<Form.Item name="submit" style={{ marginTop: '20px' }}>
					<Button htmlType="submit" type="primary" loading={loading}>
						Запросить письмо
					</Button>
				</Form.Item>
			</Form>
		</div>
	)
}

export const routePathRestore = '/restore'
